<script>
export default {
  name: 'CpDivider',
  props: {
    title: { type: String, default: 'People to Follow' },
  },
};
</script>
<template>
  <div class="divider">
    <span>{{ title }}</span>
  </div>
</template>

<style scoped>
.divider {
  display: flex;
  align-items: center;
  text-align: center;
  color: var(--neutral5);
  font-size: 14px;
  margin: 32px 0;
}

.divider::before,
.divider::after {
  content: '';
  flex: 1;
  border-bottom: 1px solid var(--neutral3);
  margin: 0 12px;
}
.divider::before {
  margin-right: 24px;
}
.divider::after {
  margin-left: 24px;
}
</style>
